









import {Component, Vue, Prop} from 'vue-property-decorator';
import Carousel from '@/components/Carousel.vue';

@Component({
	components: {
		Carousel,
	},
})
export default class Views extends Vue {
	@Prop() private details!: object;
}
